import axios from "axios"
import { USER_URL } from "src/constants"

export const getUserById = async (userId) => {
   return axios.get(`${USER_URL}/${userId}`)
}
